import { render, staticRenderFns } from "./ReviewReadingManagementDrawerHost.vue?vue&type=template&id=0357ef28&"
import script from "./ReviewReadingManagementDrawerHost.vue?vue&type=script&lang=js&"
export * from "./ReviewReadingManagementDrawerHost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports